var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plate-title",class:_vm.about?'plate-title-about':''},[_c('h3',[_vm._v(_vm._s(_vm.title)),(_vm.explain)?_c('span',[_vm._v(_vm._s(_vm.explain))]):_vm._e()]),_c('p',[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }